export default __webpack_public_path__ + "static/media/kids.3d369342.png";